import { useQuery } from '@tanstack/react-query'
import { BreedController } from 'src/controllers/breed.controller'
import { BreedDto } from 'src/dto/breed.dto'

const breedController = new BreedController()

export function useGetBreedList() {
  return useQuery<BreedDto[], Error>({
    queryKey: ['breedList'],
    queryFn: () => breedController.getBreedList()
  })
}
